module.exports = __webpack_public_path__ + "img/Visible-doctor.cf3efcf1.png";